import { useTranslation } from 'react-i18next';

import { ContactTabSectionHeading } from '~/scenes/PeopleModule/components/Tabs/ContactTab/components/ContactTabSectionHeading';
import { ContactTabSectionAccess } from '~/scenes/PeopleModule/components/Tabs/ContactTab/useContactTab';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';

import { HomeContactEditMode } from './components/HomeContactEditMode';
import { HomeContactReadMode } from './components/HomeContactReadMode';
import { useHomeContract } from './useHomeContact';

export const HomeContact = (props: ContactTabSectionAccess) => {
  const { canEdit } = props;

  const { form, actions, empData, readMode, countriesList, isLoading } =
    useHomeContract();
  const { t } = useTranslation();

  if (isLoading) {
    return <LoadingView />;
  }

  return (
    <>
      <ContactTabSectionHeading
        heading={t('laHomeContact')}
        canEdit={canEdit}
        readMode={readMode}
        {...actions}
      />
      {readMode ? (
        <HomeContactReadMode data={empData} countryList={countriesList} />
      ) : (
        <HomeContactEditMode form={form} countryList={countriesList} />
      )}
    </>
  );
};
